import { usePage } from "PFApp/use_page";
import { fetchPaginatedCollection } from "PFCore/helpers/collection";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const useCvTemplatesListPage = (initPage, accountId) => {
  const { t } = useTranslation("saasAdmin");

  const { page, setPage, mergePage, resetPage } = usePage(`cv_templates`, initPage);

  const fetch = (page = 1, perPage = 50) =>
    fetchPaginatedCollection(ApiRoute(`/api/cv_templates`), {
      account_id: accountId,
      page,
      perPage,
      apiVersion: 2
    })
      .then((response) =>
        mergePage({
          cvTemplates: {
            loaded: true,
            collection: response.entries
          },
          loaded: true
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: [t("cvTemplates.list.error")]
        })
      );

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetch();
  }, []);

  return { ...page, fetch };
};
